import React, { useRef, useState, useEffect } from "react"
import { useTranslation } from 'react-i18next';
import _ from 'lodash';

import { RowContainer, LabelTitle } from "./LabelTitle"
import { Slider } from "../ui/slider"

// import { Button } from "../ui/button"
// import { useStore } from "../../lib/states"
// import { useClickAway, useToggle } from "react-use"
// import { Textarea } from "../ui/textarea"
// import { cn } from "../../lib/utils"
// import { Slider } from "../ui/slider"

// import * as SliderPrimitive from "@radix-ui/react-slider"

import DiffusionOptionsDescEta from "./DiffusionOptionsDesc/DiffusionOptionsDescEta";

import { useHookStore } from "../../hook-store/store"
// import { resizeImageFile } from '../../utils/image/image-utils';
import { marks } from '../../utils/marks';

import "./DiffusionOptionsImagePrompt.css";


function DiffusionOptionsEta() {
    
    const [t] = useTranslation('translation');
  
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [hStore, hDispatch] = useHookStore();
    const { 
      inputEta
    } = (hStore as any).iopaintStore;

    const [showEtaDesc, setShowEtaDesc] = useState(false);

    const changeEtaHandler = (val: any) => {
      if (val >= 0.1 && val <= 1) {
        (hDispatch as any)('SET_INPUTETA', val);
      }
    }

    return (
      <div 
      // className="flex flex-col gap-1"
      >
        <div>
          <LabelTitle
            htmlFor="eta"
            text="Image blurness"
            // toolTip="The number of denoising steps. More denoising steps usually lead to a higher quality image at the expense of slower inference."
            toolTip={`eta-value-desc-blurness-clearness-contrast`}
          />

          <span
            onClick={() => {
              setShowEtaDesc(!showEtaDesc);
            }}
          >
            {' '}{marks.questionCircleOMark}
          </span>
        </div>
        <RowContainer>
          <Slider
            className="w-[180px]"
            // defaultValue={[30]}
            defaultValue={[inputEta]}
            min={0.1}
            // max={100}
            // max={4}
            max={1}
            step={0.05}
            value={[inputEta]}
            onValueChange={(vals) => { 
              changeEtaHandler(vals[0]);
              // updateSettings({ eta: vals[0] })
            }}
          />
          {/* <NumberInput
            id="eta"
            className="w-[60px] rounded-full"
            numberValue={inputEta}
            allowFloat={true}
            onNumberValueChange={(val) => {
              changeEtaHandler(val);
              // updateSettings({ eta: val })
            }}
          /> */}
          <div>{inputEta}</div>
        </RowContainer>

        {showEtaDesc && (
          <DiffusionOptionsDescEta />
        )}
      </div>
    )
  }


export default DiffusionOptionsEta